var _a;
export var IdTrackingAppsflyer = {
    Header: (_a = {}, _a["Content-Type"] = "text/plain;charset=UTF-8", _a),
    Url: process.env.REACT_APP_APPSFLYER_URL,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTrackingAppsflyer.ts
// module id = 1780
// module chunks = 3